import { createTheme } from "@material-ui/core/styles";

export default createTheme({
  palette: {
    primary: {
      main: "#40407a",
    },
    secondary: {
      main: "#f7f1e3",
    },
  },
});
